import React, { Component } from 'react';

class Todo extends Component {

  render() {

    return (
      <div className='todo'>
        <p>{this.props.title}: Moet nog gemaakt worden...</p>
      </div>
    );
  }
}

export default Todo;

